var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"text"},domProps:{"value":_vm.currentValue},on:{"input":_vm.handleInput,"blur":_vm.handleBlur}})}
var staticRenderFns = []

export { render, staticRenderFns }